import { Component, OnInit, Input } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss']
})
export class ItemListComponent implements OnInit {
  @Input('itemList') itemList:any;
  constructor(private _lightbox: Lightbox,
    private toastr: ToastrService) { }

  ngOnInit() {
  }

  openImageModal(item) {

    if (item.pictures.length) {
      let images = [];

      for (let index = 0; index < item.pictures.length; index++) {
        images.push({ src: item.pictures[index], thumb: item.pictures[index], caption: `Showing Picture of Item Id #${item.id}` });
      }

      this._lightbox.open(images, 0, { fitImageInViewPort: true, });
    }
    else{
      this.toastr.clear();
      this.toastr.info('No image available for this item', 'Image Info');
    }
  }

}
